import {wizardsService} from "@/modules/common/services";
import {settingsService} from "../../settings/services/settingsService";

const state = {
  wizard: null,
  currency: null,
  vcitaPaymentsBusinessProfessionCode: null,
  vcitaPaymentsBusinessLocation: null,
  vcitaPaymentsBusinessOwnerLocation: null,
  allowClientsToPayOnline: null,
  vcitaPaymentsPreliminaryState: null,
  square:{},
  payPal:{},
  stripe:{},
  thryv: {},
  packages:{
    payments:{
      action: 'online_payments',
      title: 'onboarding.payment_wizard.steps.call_to_upgrade.payments_package.title',
      price: {usd: '8',eur: '8', gbp: '6'},
      grey: true,
      specs: [
        'onboarding.payment_wizard.steps.call_to_upgrade.payments_package.integrations',
        'onboarding.payment_wizard.steps.call_to_upgrade.payments_package.process',
        'onboarding.payment_wizard.steps.call_to_upgrade.payments_package.charge',
        'onboarding.payment_wizard.steps.call_to_upgrade.payments_package.issue',
        'onboarding.payment_wizard.steps.call_to_upgrade.payments_package.customize',
      ]
    },
    essentials:{
      action: 'essentials',
      title: 'onboarding.payment_wizard.steps.call_to_upgrade.essentials_package.title',
      price: {usd: '19', eur: '19', gbp: '15'},
      badgeText: 'onboarding.payment_wizard.steps.call_to_upgrade.recommended',
      specsTitle: 'onboarding.payment_wizard.steps.call_to_upgrade.everything_in_payments_plus',
      specs: [
        'onboarding.payment_wizard.steps.call_to_upgrade.essentials_package.online_bookings',
        'onboarding.payment_wizard.steps.call_to_upgrade.essentials_package.client_portal',
        'onboarding.payment_wizard.steps.call_to_upgrade.essentials_package.automated_reminders',
        'onboarding.payment_wizard.steps.call_to_upgrade.essentials_package.client_management',
        'onboarding.payment_wizard.steps.call_to_upgrade.essentials_package.email_marketing',
      ]
    }
  }
};

const getters = {
  wizard: state => {
    return state.wizard
  },
  currency: state => {
    return state.currency
  },
  allowClientsToPayOnline: state => {
    return state.allowClientsToPayOnline
  },
  packages: state => {
    return state.packages
  },
  vcitaPaymentsBusinessOwnerLocation: state => {
    return state.vcitaPaymentsBusinessOwnerLocation
  },
  vcitaPaymentsBusinessProfessionCode: state => {
    return state.vcitaPaymentsBusinessProfessionCode
  },
  vcitaPaymentsBusinessLocation: state => {
    return state.vcitaPaymentsBusinessLocation
  },
  vcitaPaymentsPreliminaryState: state => {
    return state.vcitaPaymentsPreliminaryState
  }
};

const mutations = {
  setWizard : (state,wizard) => {
    state.wizard = wizard
  },
  setSquare : (state,square) => {
    state.square = square
  },
  setStripe : (state,stripe) => {
    state.stripe = stripe
  },
  setThryvPay: (state, thryvPay) => {
    state.thryv = thryvPay
  },
  setPayPal : (state,payPal) => {
    state.payPal = payPal
  },
  setPreliminaryData: (state, data) => {
    state.vcitaPaymentsBusinessProfessionCode = data.vcita_payments_business_profession_code;
    state.vcitaPaymentsBusinessLocation = data.vcita_payments_business_location;
    state.vcitaPaymentsBusinessOwnerLocation = data.vcita_payments_business_owner_location;
    state.vcitaPaymentsPreliminaryState = data.vcita_payments_preliminary_state;
    state.currency = data.currency;
  },
  setAllowClientsToPayOnline : (state,allowClientsToPayOnline) => {
    state.allowClientsToPayOnline = allowClientsToPayOnline.payments_enabled
  },
};


const actions = {
  updatePayPalEmail : async ({commit},payPalEmail) => {
    let payPalData = {'paypal_email':payPalEmail,'ewallet_type':'paypal'}
    const response = await settingsService.update(payPalData)
    commit('setPayPal', {payPalData})
    return response
  },
  updateBusinessProfession : async ({commit}, payload) => {
    const { businessId, professionCode } = payload
    const professionSettingsData = {'profession_id': professionCode};
    return await settingsService.updateBusinessSettings(businessId, professionSettingsData);
  },
  setSquareData : async ({commit},squareData) => {
    commit('setSquare', {squareData})
    return
  },
  setStripeData : async ({commit},stripeData) => {
    commit('setStripe', {stripeData})
    return
  },
  setThryvData: async ({commit},thryvData) => {
    commit('setThryvPay', {thryvData})
  },
  setPreliminaryData: async ({commit}, preliminaryData) => {
    return commit('setPreliminaryData', preliminaryData);
  },
  setPayOnlineData : async ({commit},allowClientsToPayOnline) => {
    let data = {'payments_enabled':allowClientsToPayOnline}
    const response = await settingsService.update(data)
    commit('setAllowClientsToPayOnline', data)
    return response
  },
  fetchAllowClientsToPayOnline : async  ({commit}, data) => {
    try {
      const settings = await settingsService.get()
      const allowClientsToPayOnline = {payments_enabled : settings.payments_enabled}
      commit('setAllowClientsToPayOnline', allowClientsToPayOnline)
    } catch (e) {
      console.log("fetchWizard", e)
    }
  },
  fetchWizard : async  ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.getPaymentWizard(data.business_uid)
      commit('setWizard',wizard )
    } catch (e) {
      console.log("fetchWizard", e)
    }
  },
  updateWizardFlags : async ({commit, getters}, {data}) => {
    //  Update flags only if they have changed
    const wizardFlags = getters.wizard?.flags;
    if (Object.keys(data.flags).every(key => wizardFlags[key] === data.flags[key])) return;
    try {
      let wizard = await wizardsService.updateWizardFlags(data.business_uid, data.wizard_id, data.flags)
      commit('setWizard', wizard)
    } catch (e) {
      console.log("updateWizardFlags", e)
    }
  },
  updateWizardCompleted: async ({commit}, {data}) => {
    try {
      let wizard = await wizardsService.wizardCompleted(data.business_uid, data.wizard_id, data.flags)
      commit('setWizard', wizard)
    } catch (e) {
      console.log("updateWizardCompleted", e)
    }
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
